import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { mouseContext } from '../../context/mouseContext';
import classes from './FooterCard.module.css';

const FooterLink = ({ link, content }) => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);

  return (
    <NavLink
      to={`/${link}`}
      className={({ isActive }) =>
        isActive ? `${classes.activeLink}` : ''
      }
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      {content}
    </NavLink>
  );
};

export default FooterLink;
